export const scrollbarDataIdAttribute = 'data-scrollbar-id'

export const textMagicLink = 'https://www.textmagic.com/'
